import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";

// Components
import { SurveyProvider, useSurveyContext } from "./Data/SurveyFormContext";
import { UserSearchProvider } from "Providers/UserSearchProvider";
import PulseBuilderV2Integrated from "./SurveyFormCategories/PulseBuilderV2Integrated";

// Constants
import { CLEAR_TASK_TEMPLATE } from "constants/actions";

const SurveyFormPage = ({ mode, surveyId, initialSurveyData }) => {
  const dispatch = useDispatch();
  const { updateFormData } = useSurveyContext();

  useEffect(() => {
    if (initialSurveyData) {
      updateFormData(initialSurveyData); // Initialize with passed data
    } else if (mode === "edit" && surveyId) {
      updateFormData(surveyId);
    }

    // Remove updateFormData from dependencies
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialSurveyData, mode, surveyId]);

  const clearState = () => {
    dispatch({
      type: CLEAR_TASK_TEMPLATE,
    });
  };

  return <PulseBuilderV2Integrated />;
};

SurveyFormPage.propTypes = {
  mode: PropTypes.oneOf(["create", "edit"]).isRequired, // "create" or "edit"
  surveyId: PropTypes.string, // Required only for "edit"
};

const SurveyFormPageWrapper = (props) => {
  const location = useLocation();
  // Only use location state initialSurveyData in edit mode, not create mode
  // This prevents previous edit session data from persisting in create mode
  const initialSurveyData = (props.mode === "edit" && location.state?.initialSurveyData) 
    ? location.state.initialSurveyData 
    : null;

  return (
    <UserSearchProvider>
      <SurveyProvider
        initialFormData={initialSurveyData}
        surveyId={props.surveyId}
        mode={props.mode}
      >
        <SurveyFormPage {...props} initialSurveyData={initialSurveyData} />
      </SurveyProvider>
    </UserSearchProvider>
  );
};

export default SurveyFormPageWrapper;

